<template>
    <div
        class="modal fade"
        id="createTaskModal"
        role="dialog"
        aria-labelledby="participationRelationTypeUpdateModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5
                        class="modal-title"
                        id="participationRelationTypeUpdateModalLabel"
                    >{{$t('participationRelationType.edit')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ParticipationRelationTypeEditCard
                        v-model="model"
                        v-if="showEditor"
                        :create="false"
                        @save="onSave"
                        @cancel="onCancel"
                    ></ParticipationRelationTypeEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ParticipationRelationType } from "../../../models/models";
import ParticipationRelationTypeEditCard from "./ParticipationRelationTypeEditCard";

export default {
    components: {
        ParticipationRelationTypeEditCard,
    },
    props: {
        value: {
            type: Object,
            required: false,
        },
        show: {
            type: Boolean,
            default: false,
        },
        profileManagement: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showEditor: false,
            model: new ParticipationRelationType(),
        };
    },
    methods: {
        onClose() {
            this.$emit("onClose", { ...this.model });
            this.model = new ParticipationRelationType();
            this.$validator.reset();
        },
        hide() {
            $(this.$el).modal("hide");
        },
        onSave(model) {
            this.$emit("onSave", model);
            this.onClose();
        },
        onCancel() {
            this.onClose();
        },
    },
    mounted() {
        // add modal close listener
        $(this.$el).on("hidden.bs.modal", this.onClose);
    },
    beforeDestroy() {
        // remove listener
        $(this.$el).off("hidden.bs.modal");
    },
    watch: {
        show: function (val) {
            if (val) {
                this.model = new ParticipationRelationType(this.value);
                this.showEditor = true;
                $(this.$el).modal("show");
            } else {
                $(this.$el).modal("hide");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.bmd-form-group {
    padding-top: 0px !important;
}
</style>
